export default "__VITE_ASSET__DVGTP2dZ__"